module.exports = __webpack_public_path__ + "static/img/ross_noble_ani_extended_size_00068-fs8.adbf477.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/animation/ross_noble_ani_extended_size_00068-fs8.png
// module id = 221
// module chunks = 0